module.exports = __webpack_public_path__ + "static/img/bottom2.0bec6cd5.png";